module.exports = __webpack_public_path__ + "static/media/cert_163.76b0c321.jpg";